/* eslint-disable jsdoc/require-example */
import {removeClassesFromElement} from 'Utils/elementUtils';

/**
 * @description Open and close items by adding a class on it.
 */
export default class Accordion {
    /**
     * @description Wrapper where the are.
     * @param {HTMLElement} domElement - Dom target element for init the class.
     */
    constructor(domElement) {
        if(domElement.getAttribute('data-accordion-initialized') === 'true') {
            throw new Error('Module already initialized');
        }

        this.domElement = domElement;
        this.domElement.dataset.accordionInitialized = 'true';

        this.domButtonsList = [
            ...this.domElement.querySelectorAll('[data-target]')
        ];
        this.collapsedClassName = this.domElement.getAttribute('data-toggle');
        this.icons = this.domButtonsList.map(button => (
            {icons: [...button.querySelectorAll('[data-icon]')]}
        ));
        this.init();
        this.initListeners();
    }

    /**
     * @description Get item name opened by default and open it.
     */
    init() {
        const accordionItemOpened = this.domElement
            .getAttribute('data-accordion-opened-default');

        this.defaultToggledItems(accordionItemOpened);
    }

    /**
     * @description Separate the items and toggle it.
     * @param {string} items - The default opened items.
     */
    defaultToggledItems(items) {
        if(!items) {
            return;
        }

        items
            .split(' ')
            .filter(item => item !== '')
            .forEach(item => {
                this.toggleItem(item, true);
                this.toggleIcon(item);
            });
    }

    /**
     * @description Init the listeners on each buttons.
     */
    initListeners() {
        this.domButtonsList.forEach(button => {
            button.addEventListener('click', this.handleButtonClick.bind(this));
        });
    }

    /**
     * @description Get the element to trigger on the target and trigger it.
     * @param {Event} event - We get the target to trigger.
     */
    handleButtonClick(event) {
        event.stopPropagation();
        const target = event.currentTarget.getAttribute('data-target');
        this.toggleItem(target);
        this.toggleIcon(target);
    }

    /**
     * @description Change de style to the icon when opened or closed.
     * @param  {string} targetId - Id of the icon to toggle.
     */
    toggleIcon(targetId) {
        const domButton = this.domElement
            .querySelector(`[data-target="${targetId}"]`);

        if(!domButton) {
            return;
        }

        const domIcon = domButton.querySelector('[data-icon]');

        if(!domIcon) {
            return;
        }

        domIcon.classList.toggle(domIcon.getAttribute('data-icon-toggle'));
    }

    /**
     * @description Toggle the next opened item.
     * @param  {string} targetId - Id of the new target to be toggle.
     * @param  {boolean} isOpen - Set the state at opened.
     */
    toggleItem(targetId, isOpen = false) {
        const domItem = this.domElement
            .querySelector(`[data-accordion-item="${targetId}"]`);

        if(!domItem) {
            return;
        }

        const isItemOpened = domItem.classList
            .contains(this.collapsedClassName) === true || isOpen;

        if(isItemOpened) {
            this.expandAccordion(targetId, domItem);
        } else {
            this.collapseAccordion(targetId, domItem);
        }
    }

    expandAccordion(targetId, domItem) {
        const dombuttons = this.domElement
            .querySelector(`[data-target="${targetId}"] button`);
        removeClassesFromElement(domItem, this.collapsedClassName);
        dombuttons.setAttribute('aria-expanded', true);
        dombuttons.setAttribute('aria-label', 'la section est dépliée');
    }

    collapseAccordion(targetId, domItem) {
        const dombuttons = this.domElement
            .querySelector(`[data-target="${targetId}"] button`);
        domItem.classList.add(this.collapsedClassName);
        dombuttons.setAttribute('aria-expanded', false);
        dombuttons.setAttribute('aria-label', 'la section est pliée');
    }
}
